import { Logger } from "../../Logger";
import { GVCInternalEvent } from "../../EventEmitter/GVCEventEmitter";
import { WebRTCTransportErrorCode, } from "../../EventEmitter/WebRTCTransportEvents";
export const TRANSPORT_DISCONNECTED_GRACE_PERIOD_MS = 10000;
export class TransportConnectionStateHelper {
    _serverURL;
    _eventEmitter;
    cleanupFns = [];
    _monitorReason = "initialConnect";
    _currentState = "new";
    _sawQuickDisconnect = false;
    _lastConnectedTimestamp = 0;
    _connectionStateMonitorTimer;
    constructor(serverURL, eventEmitter) {
        this._serverURL = serverURL;
        this._eventEmitter = eventEmitter;
        this.cleanupFns = [
            this._eventEmitter.addEventListener(GVCInternalEvent.WebRTCTransportConnectionStateChange, this._onConnectionStateChanged),
        ];
    }
    destroy() {
        this.cleanupFns.forEach((f) => f());
        if (this._connectionStateMonitorTimer) {
            clearTimeout(this._connectionStateMonitorTimer);
            this._connectionStateMonitorTimer = undefined;
        }
    }
    startNewConnectionStateMonitorTimer(id, reason) {
        this._monitorReason = reason;
        this._lastConnectedTimestamp = 0;
        if (this._connectionStateMonitorTimer) {
            clearTimeout(this._connectionStateMonitorTimer);
            this._connectionStateMonitorTimer = undefined;
        }
        this._startConnectionStateMonitorTimerIfNeeded(id);
    }
    _onConnectionStateChanged = (context) => {
        const { id, connectionState } = context;
        this._currentState = connectionState;
        if (connectionState === "failed") {
            this._eventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.FailedState, {
                sfuAddr: this._serverURL,
                id,
                connectionState,
            });
        }
        else if (connectionState === "connected") {
            this._lastConnectedTimestamp = Date.now();
            if (this._connectionStateMonitorTimer) {
                clearTimeout(this._connectionStateMonitorTimer);
                this._connectionStateMonitorTimer = undefined;
            }
        }
        else if (connectionState === "disconnected") {
            if (!this._lastConnectedTimestamp) {
                Logger.error("Missing lastConnectedTimestamp, ignore disconnected state");
                return;
            }
            const diff = Date.now() - this._lastConnectedTimestamp;
            if (diff < TRANSPORT_DISCONNECTED_GRACE_PERIOD_MS) {
                if (this._sawQuickDisconnect) {
                    this._eventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.UnstableConnection, {
                        sfuAddr: this._serverURL,
                        id,
                        connectionState,
                    });
                }
                else {
                    this._sawQuickDisconnect = true;
                }
            }
            else {
                this._sawQuickDisconnect = false;
            }
            this._startConnectionStateMonitorTimerIfNeeded(id);
        }
    };
    _startConnectionStateMonitorTimerIfNeeded(id) {
        if (this._connectionStateMonitorTimer) {
            Logger.error("There is already a pending timer, skip setting timer");
            return;
        }
        this._connectionStateMonitorTimer = setTimeout(() => {
            this._connectionStateMonitorTimer = undefined;
            if (this._currentState !== "connected") {
                if (this._sawQuickDisconnect) {
                    this._eventEmitter.publishWebRTCTransportError(WebRTCTransportErrorCode.UnstableConnection, {
                        sfuAddr: this._serverURL,
                        id,
                        connectionState: this._currentState,
                    });
                }
                else {
                    const hasBeenConnected = this._lastConnectedTimestamp !== 0;
                    const isIceRestart = this._monitorReason === "iceRestart";
                    const errorCode = hasBeenConnected
                        ? WebRTCTransportErrorCode.Disconnected
                        : isIceRestart
                            ? WebRTCTransportErrorCode.ICERestartFailure
                            : WebRTCTransportErrorCode.FailedToConnect;
                    this._eventEmitter.publishWebRTCTransportError(errorCode, {
                        sfuAddr: this._serverURL,
                        id,
                        connectionState: this._currentState,
                    });
                }
            }
        }, TRANSPORT_DISCONNECTED_GRACE_PERIOD_MS);
    }
}
//# sourceMappingURL=TransportConnectionStateHelper.js.map